import { useEffect } from 'react';
import { Language } from './useTranslation';

// SEO data for each language
const seoData: Record<Language, {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogDescription: string;
  twitterTitle: string;
  twitterDescription: string;
  hreflang: string;
  canonical: string;
}> = {
  vi: {
    title: "DeployPro - Dịch vụ triển khai ứng dụng chuyên nghiệp",
    description: "Dịch vụ triển khai ứng dụng chuyên nghiệp cho Android, iOS & Web. Triển khai nhanh chóng, an toàn và tối ưu chi phí lên Google Play, App Store và các nền tảng cloud.",
    keywords: "triển khai ứng dụng, triển khai mobile app, triển khai web app, triển khai Android, triển khai iOS, Google Play, App Store, triển khai cloud, dịch vụ triển khai chuyên nghiệp",
    ogTitle: "DeployPro - Dịch vụ triển khai ứng dụng chuyên nghiệp",
    ogDescription: "Dịch vụ triển khai ứng dụng chuyên nghiệp cho Android, iOS & Web. Triển khai nhanh chóng, an toàn và tối ưu chi phí.",
    twitterTitle: "DeployPro - Dịch vụ triển khai ứng dụng chuyên nghiệp",
    twitterDescription: "Dịch vụ triển khai ứng dụng chuyên nghiệp cho Android, iOS & Web. Triển khai nhanh chóng, an toàn và tối ưu chi phí.",
    hreflang: "vi-VN",
    canonical: "https://deploypro.vercel.app/vi/"
  },
  en: {
    title: "DeployPro - Professional Application Deployment Service",
    description: "Professional application deployment service for Android, iOS & Web applications. Fast, secure, and cost-optimized deployment to Google Play, App Store, and cloud platforms.",
    keywords: "app deployment, mobile app deployment, web app deployment, Android deployment, iOS deployment, Google Play, App Store, cloud deployment, professional deployment service",
    ogTitle: "DeployPro - Professional Application Deployment Service",
    ogDescription: "Professional application deployment service for Android, iOS & Web applications. Fast, secure, and cost-optimized deployment.",
    twitterTitle: "DeployPro - Professional Application Deployment Service",
    twitterDescription: "Professional application deployment service for Android, iOS & Web applications. Fast, secure, and cost-optimized deployment.",
    hreflang: "en-US",
    canonical: "https://deploypro.vercel.app/"
  },
  zh: {
    title: "DeployPro - 专业应用程序部署服务",
    description: "专业的Android、iOS和Web应用程序部署服务。快速、安全、成本优化的部署到Google Play、App Store和云平台。",
    keywords: "应用部署, 移动应用部署, Web应用部署, Android部署, iOS部署, Google Play, App Store, 云部署, 专业部署服务",
    ogTitle: "DeployPro - 专业应用程序部署服务",
    ogDescription: "专业的Android、iOS和Web应用程序部署服务。快速、安全、成本优化的部署。",
    twitterTitle: "DeployPro - 专业应用程序部署服务",
    twitterDescription: "专业的Android、iOS和Web应用程序部署服务。快速、安全、成本优化的部署。",
    hreflang: "zh-CN",
    canonical: "https://deploypro.vercel.app/zh/"
  },
  ja: {
    title: "DeployPro - プロフェッショナルアプリケーションデプロイメントサービス",
    description: "Android、iOS、Webアプリケーション向けのプロフェッショナルデプロイメントサービス。Google Play、App Store、クラウドプラットフォームへの高速、安全、コスト最適化されたデプロイメント。",
    keywords: "アプリデプロイメント, モバイルアプリデプロイメント, Webアプリデプロイメント, Androidデプロイメント, iOSデプロイメント, Google Play, App Store, クラウドデプロイメント, プロフェッショナルデプロイメントサービス",
    ogTitle: "DeployPro - プロフェッショナルアプリケーションデプロイメントサービス",
    ogDescription: "Android、iOS、Webアプリケーション向けのプロフェッショナルデプロイメントサービス。高速、安全、コスト最適化されたデプロイメント。",
    twitterTitle: "DeployPro - プロフェッショナルアプリケーションデプロイメントサービス",
    twitterDescription: "Android、iOS、Webアプリケーション向けのプロフェッショナルデプロイメントサービス。高速、安全、コスト最適化されたデプロイメント。",
    hreflang: "ja-JP",
    canonical: "https://deploypro.vercel.app/ja/"
  },
  th: {
    title: "DeployPro - บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพ",
    description: "บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพสำหรับ Android, iOS & Web แอปพลิเคชัน ปรับใช้อย่างรวดเร็ว ปลอดภัย และประหยัดต้นทุนไปยัง Google Play, App Store และแพลตฟอร์มคลาวด์",
    keywords: "การปรับใช้แอปพลิเคชัน, การปรับใช้แอปมือถือ, การปรับใช้เว็บแอป, การปรับใช้ Android, การปรับใช้ iOS, Google Play, App Store, การปรับใช้คลาวด์, บริการปรับใช้อย่างมืออาชีพ",
    ogTitle: "DeployPro - บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพ",
    ogDescription: "บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพสำหรับ Android, iOS & Web แอปพลิเคชัน ปรับใช้อย่างรวดเร็ว ปลอดภัย และประหยัดต้นทุน",
    twitterTitle: "DeployPro - บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพ",
    twitterDescription: "บริการปรับใช้แอปพลิเคชันอย่างมืออาชีพสำหรับ Android, iOS & Web แอปพลิเคชัน ปรับใช้อย่างรวดเร็ว ปลอดภัย และประหยัดต้นทุน",
    hreflang: "th-TH",
    canonical: "https://deploypro.vercel.app/th/"
  },
  lo: {
    title: "DeployPro - ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບ",
    description: "ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບສໍາລັບແອັບ Android, iOS & Web. ເປີດໃຊ້ງານໄວ, ປອດໄພ ແລະປະຫຍັດຄ່າໃຊ້ຈ່າຍໄປຍັງ Google Play, App Store ແລະແພລດຟອມຄລາວດ໌",
    keywords: "ການເປີດໃຊ້ງານແອັບ, ການເປີດໃຊ້ງານແອັບມືຖື, ການເປີດໃຊ້ງານເວັບແອັບ, ການເປີດໃຊ້ງານ Android, ການເປີດໃຊ້ງານ iOS, Google Play, App Store, ການເປີດໃຊ້ງານຄລາວດ໌, ການບໍລິການເປີດໃຊ້ງານຢ່າງມືອາຊີບ",
    ogTitle: "DeployPro - ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບ",
    ogDescription: "ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບສໍາລັບ Android, iOS & Web. ເປີດໃຊ້ງານໄວ, ປອດໄພ ແລະປະຫຍັດຄ່າໃຊ້ຈ່າຍ",
    twitterTitle: "DeployPro - ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບ",
    twitterDescription: "ການບໍລິການເປີດໃຊ້ງານແອັບຢ່າງມືອາຊີບສໍາລັບ Android, iOS & Web. ເປີດໃຊ້ງານໄວ, ປອດໄພ ແລະປະຫຍັດຄ່າໃຊ້ຈ່າຍ",
    hreflang: "lo-LA",
    canonical: "https://deploypro.vercel.app/lo/"
  },
  km: {
    title: "DeployPro - សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈ",
    description: "សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈសម្រាប់កម្មវិធី Android, iOS & Web. ដាក់ឱ្យប្រើប្រាស់លឿន, សុវត្ថិភាព និងប្រសើរតម្លៃទៅកាន់ Google Play, App Store និងវេទិកាពពក",
    keywords: "ការដាក់ឱ្យប្រើប្រាស់កម្មវិធី, ការដាក់ឱ្យប្រើប្រាស់កម្មវិធីម៉ាស៊ីនទូរស័ព្ទ, ការដាក់ឱ្យប្រើប្រាស់កម្មវិធីគេហទំព័រ, ការដាក់ឱ្យប្រើប្រាស់ Android, ការដាក់ឱ្យប្រើប្រាស់ iOS, Google Play, App Store, ការដាក់ឱ្យប្រើប្រាស់ពពក, សេវាកម្មដាក់ឱ្យប្រើប្រាស់ដោយវិជ្ជាជីវៈ",
    ogTitle: "DeployPro - សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈ",
    ogDescription: "សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈសម្រាប់ Android, iOS & Web. ដាក់ឱ្យប្រើប្រាស់លឿន, សុវត្ថិភាព និងប្រសើរតម្លៃ",
    twitterTitle: "DeployPro - សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈ",
    twitterDescription: "សេវាកម្មដាក់ឱ្យប្រើប្រាស់កម្មវិធីដោយវិជ្ជាជីវៈសម្រាប់ Android, iOS & Web. ដាក់ឱ្យប្រើប្រាស់លឿន, សុវត្ថិភាព និងប្រសើរតម្លៃ",
    hreflang: "km-KH",
    canonical: "https://deploypro.vercel.app/km/"
  }
};

export const useSEO = (language: Language) => {
  useEffect(() => {
    const seo = seoData[language];
    
    // Update document title
    document.title = seo.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', seo.description);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', seo.keywords);
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', seo.ogTitle);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', seo.ogDescription);
    }
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', seo.twitterTitle);
    }
    
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', seo.twitterDescription);
    }
    
    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', seo.canonical);
    }
    
    // Update HTML lang attribute
    document.documentElement.lang = seo.hreflang;
    
    // Update structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "DeployPro",
      "url": "https://deploypro.vercel.app",
      "logo": "https://deploypro.vercel.app/logo.png",
      "description": seo.description,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+84-961-801-543",
        "contactType": "customer service",
        "availableLanguage": ["English", "Vietnamese", "Chinese", "Japanese", "Thai", "Lao", "Khmer"]
      },
      "sameAs": [
        "https://www.facebook.com/profile.php?id=61577741002396"
      ],
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "VN"
      },
      "serviceType": "Application Deployment",
      "areaServed": "Worldwide"
    };
    
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
    
    console.log(`SEO updated for language: ${language}`); // Debug log
    
  }, [language]);
};
